export default __webpack_public_path__ + "images/98523a9688ca1ad291ab7dc1b7c0edb2.webp";